<div class="modal-content" *ngIf="params['component'] === 'GroupSelection'">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <button type="button" class="btn btn-link close" (click)="hide()" aria-label="Close"></button>

        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                    <div class="col-sm-10">
                        <div class="alert alert-danger">
                            <div *ngFor="let error of errorMessage">
                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                {{ error }}
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="responseMessage" class="row form-group" role="alert">
                    <div class="col-sm-10">
                        <div class="alert-success alert">
                            <i class="fas fa-check" aria-hidden="true"></i> {{ responseMessage | translate }}
                        </div>
                    </div>
                </div>

                <div class="mt-2 row">
                    <div #domainName class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select (selectionChange)="collectFeelings($event)"
                                        class="matSelect-domains"
                                        #matDomain
                                        [(ngModel)]="domainIds"
                                        [ngModelOptions]="{standalone: true}"
                                        [placeholder]="'Domains' | translate"
                                        multiple>
                                <ng-container *ngFor="let domain of domains">
                                    <mat-option [class.hidden]="domain['hidden']" [selected]="form.controls['items']?.value?.indexOf(domain['id']) > -1" [value]="domain['id']">
                                        {{ domain['name_' + itemLanguage] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div *ngFor="let group of getGroups.controls; let i = index">
                    <div class="container">
                        <div class="row mr-t--md">
                            <div #nameFG *ngFor="let language of languages" class="form-group col-xs-6">
                                <mat-form-field class="ps-content">
                                    <textarea matInput [placeholder]="('Group question' | translate) + ' ' + language['locale']"
                                              [formControl]="group.controls['name_' + language['locale']]"
                                              rows="2">
                                    </textarea>
                                    <small class="form-text text-danger" [hidden]="(group.controls['name_' + language['locale']].valid
                                                                        || group.controls['name_' + language['locale']].pristine
                                                                        && !formSubmitted)">
                                        {{ 'Require at least 3 characters.' | translate }}
                                    </small>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="container mr-b--md">
                        <div *ngIf="this.authService.isSuperAdmin" class="mt-2 row">
                            <div #feelingName class="form-group col-xs-4">
                                <mat-form-field class="">
                                    <mat-select #matFeeling required
                                                class="matSelect-domains"
                                                [placeholder]="'Feelings' | translate"
                                                (openedChange)="toggleMatSelect($event)"
                                                [(ngModel)]="feelingsIdSelectedByGroup[i]"
                                                [ngModelOptions]="{standalone: true}"
                                                multiple>
                                        <input formControlName="searchTxt"
                                               matInput
                                               type="text"
                                               class="matSelect-domains--filter"
                                               [placeholder]="('Search' | translate)">
                                        <ng-container *ngFor="let feeling of filteredFeelings | searchArray : form.controls['searchTxt'].value : 'name_' + itemLanguage ">
                                            <mat-option
                                                    [class.hidden]="feeling['hidden']"
                                                    #matOption
                                                    [value]="feeling['id']"
                                                    (click)="toggleFeeling(feeling, i)">
                                                {{ feeling['id'] }} - {{ feeling['name_' + itemLanguage] | translate }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                    <small class="form-text text-danger" [hidden]="(feelingsIdSelectedByGroup[i]?.length > 0 || !formSubmitted)">
                                        {{ 'Require at least 1 feeling.' | translate }}
                                    </small>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <label class="col-xs-12 lbl-card">
                                {{ 'Selected feelings' | translate}}
                            </label>
                            <div class="col-xs-8 selected-feelings">
                                <ng-container *ngFor="let feeling of feelingsSelectedByGroup[i]">
                                    <div class="row selected-feelings--item">
                                        <div class="col-xs-11">
                                            <label [for]="'feeling-' + i + '-' + feeling['id']" class="mb-0">
                                                {{ feeling['id'] }} | {{feeling['name_' + itemLanguage]}} <br/>
                                            </label>
                                        </div>

                                        <div class="col-xs-1">
                                            <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="removeFeeling(feeling, i)">
                                                <i class="far fa-trash-alt table--grid__actions__links__icon"
                                                   attr.name="{{ 'Delete' | translate }}" aria-hidden="true"
                                                   title="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-6 offset-xs-3 mt-2 align-content-center">
                                <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="addNewGroupData()">
                                    {{ 'Add group' | translate }}
                                </button>
                                <button *ngIf="i > 0" type="button" class="btn btn-secondary" (click)="deleteNewGroupData(i)">
                                    {{ 'Delete' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>

                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hide()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="submitData()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>